import { get, set } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default Route.extend({
  router: service(),

  model() {
    return this.modelFor('admin.users.add');
  },

  afterModel(model) {
    // If it's an Org-Admin, then automatically set their selectedFundIds and save the user
    if (get(model, 'changeset.role') === 'Org-Admin') {
      let firstFund = get(model, 'funds').find((fund) => {
        return get(fund, 'active');
      });
      set(model, 'selectedFundIds', [get(firstFund, 'id')]);
      this.router.transitionTo('admin.users.add.save');
    }
  },

  redirect(model) {
    get(model, 'changeset')
      .validate()
      .then(() => {
        if (get(model, 'changeset.isInvalid')) {
          this.router.transitionTo('admin.users.add');
        }
      });
  },

  resetController(controller, isExiting) {
    if (isExiting) {
      controller.reset();
    }
  },
});
